import React from "react";

const EditClassroom = ({
  isOpen,
  onClose,
  classroom,
  setClassroom,
  description,
  setDescription,
  members,
  setMembers,
  handleUpdate,
}) => {
  if (!isOpen) return null;

  const onSubmit = (e) => {
    e.preventDefault();
    handleUpdate();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[20px] font-bold text-[#400167]">
            Edit Classroom
          </h2>
          <button
            onClick={onClose}
            className="text-[30px] text-[#758E95] hover:text-gray-900"
          >
            &times;
          </button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="flex flex-col mb-6">
            <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
              Classroom Name
            </label>
            <input
              type="text"
              value={classroom}
              onChange={(ev) => setClassroom(ev.target.value)}
              placeholder="Title"
              className="w-full py-2 px-4 focus:outline-none border border-[#000000] rounded-lg"
            />
          </div>
          <div className="flex flex-col mb-6">
            <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
              Description
            </label>
            <textarea
              value={description}
              onChange={(ev) => setDescription(ev.target.value)}
              placeholder="Description"
              className="w-full py-2 px-4 focus:outline-none border border-[#000000] rounded-lg h-24"
            ></textarea>
          </div>
          <div className="flex flex-col mb-6">
            <label className="mb-2 text-[16px] text-[#000] font-satoshi font-semibold">
              Add members
            </label>
            <input
              type="text"
              value={members.join(", ")}
              onChange={(ev) => setMembers(ev.target.value.split(", "))}
              placeholder="Add Members"
              className="w-full py-2 px-4 focus:outline-none border border-[#000000] rounded-lg"
            />
          </div>
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={onClose}
              className="py-2 px-4 bg-transparent border border-purple text-purple-500 rounded-lg hover:bg-purple-500 hover:text-white transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="py-2 px-4 bg-purple text-white rounded-lg hover:bg-purple-600 transition"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditClassroom;
